export class MaterialEditorHTMLPrinter {

    public static createInputBox(valueName, value) {
        return $(`
            <div class="flex-container row">
                <h3>${valueName}</h3>
                <input type="number" class="textureinput_singleinput" data-valuename=${valueName} value="${value}">            
            </div>`);
    }

    public static createInputBoxForArrayData(valueName, value) {
        return $( `
            <div class="flex-container row">
                <h3>${valueName}</h3>
                <textarea class="textureinput_arrayinput" data-valuename=${valueName}">${value}</textarea>
            </div>
        `);
    }


    public static createInputVec2(valueName, value: { x, y }) {

        return $(`
        <div class="textureInput">
            <div class="flex-container row">
                <h3>${valueName}</h3>
                <div>
                    <label>x:</label>
                    <input type="number" class="textureinput_componentinput" data-valuename="${valueName}" 
                        data-component="x" value='${parseFloat(value.x)}'
                    >    
                </div>
                <div>
                    <label>y:</label>
                    <input type="number" class="textureinput_componentinput" data-valuename="${valueName}" 
                        data-component="y" value='${parseFloat(value.y)}'
                    >
                </div>                
            </div>
        </div>`);
    }

    public static createTextureDiv(textureName, texture) {
        const src = texture !== "" ? 'data:image/png;base64,' + texture : "";
        return $(`
            <div class="textureInput${texture === "" ? " emptyTexture" : ""}" data-texturename="${textureName}">
                <div class="flex-container row">
                    <h3 class="texturename">${textureName}</h3>                          
                    <img class="texture-image" data-texturename="${textureName}" src="${src}" alt="Empty texture.">
                    <div class="flex-container column">       
                            <label class="standard-btn-grey material-ripple" for="textureinput_${textureName}"><span class="texturebuttontext"></span></label>
                            <input class="fileinput" id="textureinput_${textureName}" type="file" data-texturename="${textureName}">
                            <label class="standard-btn-grey material-ripple materialeditor_cleartexture" data-texturename="${textureName}">löschen</label>
                    </div>
                </div>
            </div>`)
    }

    public static createCheckBox(valueName, value) {
        return $(`
            <div class="textureInput">
                <div class="flex-container row">
                    <h3>${valueName}</h3>
                    <input type="checkbox" class="textureinput_checkbox" data-valuename="${valueName}" ${value ? "checked=\"checked\"" : ""}>
                </div>
            </div>`);
    }

    public static createEditor(materialName, children) {
        const editor = $('<div id="materialEditor"></div></br>').appendTo('body');
        $(`
            <div class="blackbg">
                <h2 style='float:left'>Material: ${materialName}</h2>
                <input style="float:right" type="button" id="materialEditorClose" value="x">
            </div> `).appendTo('#materialEditor');
        children.forEach(c => editor.append(c));
        $('<div class="flex-container"><a class="standard-btn-blue material-ripple" id="materialEditorSave" href="#">Speichern</a></div>').appendTo('#materialEditor');
    }
}
